import { useEffect, useState } from 'react';
import { collection, onSnapshot, query } from 'firebase/firestore';
import { db } from '../firebase';

// Hook: useFirestoreData
// path: collection path (e.g., 'users')
// returns: { data: Array<{id, ...doc}>, loading, error }
export default function useFirestoreData(path) {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!path) return;
        const col = collection(db, path);
        const q = query(col);
        const unsub = onSnapshot(q, (snap) => {
            const docs = snap.docs.map(d => ({ id: d.id, ...d.data() }));
            setData(docs);
            setLoading(false);
        }, (err) => {
            console.error('useFirestoreData error', err);
            setError(err);
            setLoading(false);
        });

        return () => unsub();
    }, [path]);

    return { data, loading, error };
}
